var _title, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSpeakerNew = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "11px",
    viewBox: "0 0 10 11",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "DCE0565F-B4EE-41C2-80C0-26EF60E2E44E")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.423529 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "teacher/studio/audio/all-panels",
    transform: "translate(-686.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panel/controller/audio/editor-teacher",
    transform: "translate(507.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panel/controller/audio/loops",
    transform: "translate(0.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panel/audio/stem/active/teacher",
    transform: "translate(104.000000, 38.877193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 11.663158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/volume/off",
    transform: "translate(56.000000, 0.000000)",
    filter: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 5.831579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/volume",
    transform: "translate(1.000000, 0.971930)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0,3.19799885 L0,6.52275398 L2.22227447,6.52275398 L3.2937634,7.59149375 C3.684789,7.98151608 4.31795346,7.98070277 4.70797579,7.58967717 C4.89495681,7.40221518 4.99996131,7.14825066 4.99996131,6.88347926 L4.99996131,2.83719341 C4.99996131,2.28490866 4.55224606,1.83719341 3.99996131,1.83719341 C3.73517691,1.83719341 3.48120103,1.94220819 3.29373685,2.1292054 L2.22227447,3.19799885 L2.22227447,3.19799885 L0,3.19799885 Z M7.49994345,4.86037641 C7.49971704,3.91328865 6.96159718,3.04808152 6.11099437,2.62717995 L6.11099437,7.08796235 C6.96215571,6.67056951 7.50097804,5.80640944 7.49994345,4.86037641 Z M6.11099437,1.14205339 C7.7592781,1.63258919 8.88891558,3.14459741 8.88891558,4.86027251 C8.88891558,6.57594762 7.7592781,8.08795584 6.11099437,8.57849164 L6.11099437,9.71929825 C8.38575725,9.2035832 10,7.18644716 10,4.85964912 C10,2.53285108 8.38575725,0.51571505 6.11099437,0 L6.11099437,1.14205339 Z",
    id: "Path_387"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeakerNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speaker-new.1bfe8335.svg";
export { ForwardRef as ReactComponent };